if (!customElements.get('ae-product-image-interactions')) {
  customElements.define('ae-product-image-interactions', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('.ae-pdp');
      if (!this.root) return;
      this.root.setAttribute('data-ae-image-interactions', '');
      this.mode = window.matchMedia('(min-width: 990px) and (any-hover: hover) and (any-pointer: fine)');
      this.revealImages();
      this.onOver = this.over.bind(this);
      this.onOut = this.out.bind(this);
      this.onMove = this.move.bind(this);
      this.onReset = this.reset.bind(this);
      this.onEscape = (event) => { if (event.key === 'Escape') this.reset(); };
      this.onModeChange = () => { this.reset(); this.revealImages(); };
      this.root.addEventListener('pointerover', this.onOver, true);
      this.root.addEventListener('pointerout', this.onOut, true);
      this.root.addEventListener('pointermove', this.onMove, true);
      this.root.addEventListener('pointerdown', this.onReset, true);
      document.addEventListener('keydown', this.onEscape);
      this.mode.addEventListener('change', this.onModeChange);
      window.addEventListener('resize', this.onReset);
      window.addEventListener('blur', this.onReset);
    }

    disconnectedCallback() {
      if (!this.root) return;
      this.root.removeEventListener('pointerover', this.onOver, true);
      this.root.removeEventListener('pointerout', this.onOut, true);
      this.root.removeEventListener('pointermove', this.onMove, true);
      this.root.removeEventListener('pointerdown', this.onReset, true);
      document.removeEventListener('keydown', this.onEscape);
      this.mode.removeEventListener('change', this.onModeChange);
      window.removeEventListener('resize', this.onReset);
      window.removeEventListener('blur', this.onReset);
      this.reset();
      this.root.removeAttribute('data-ae-image-interactions');
    }

    over(event) {
      if (!this.mode.matches || event.pointerType === 'touch') return;
      this.revealImages();
      const thumbnail = event.target.closest('.thumbnail-list .thumbnail, .product__thumbnails .product__thumbnail');
      if (thumbnail) {
        if (thumbnail.contains(event.relatedTarget)) return;
        this.reset();
        const item = thumbnail.closest('[data-target], [data-media-id]');
        const gallery = thumbnail.closest('media-gallery');
        const target = item?.dataset.target || item?.dataset.mediaId;
        if (!target || !gallery) return;
        this.thumbnail = thumbnail;
        this.timer = setTimeout(() => {
          if (!this.mode.matches || this.thumbnail !== thumbnail || !thumbnail.isConnected) return;
          this.selectThumbnail(gallery, target);
        }, 100);
        return;
      }
      const opener = event.target.closest('.product__media-list .product__modal-opener--image');
      if (!opener || opener.contains(event.relatedTarget)) return;
      this.reset();
      this.opener = opener;
      opener.classList.add('ae-image-hover-active');
      this.move(event);
    }

    revealImages() {
      if (!this.mode.matches) return;
      this.root.querySelectorAll('media-gallery use-animate').forEach(element => element.setAttribute('animate', ''));
    }

    selectThumbnail(gallery, target) {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(target, false, false);
        return;
      }
      // Image hover is independent of the theme's deferred gallery scripts.
      const items = Array.from(gallery.querySelectorAll('.product__media-list [data-media-id]'));
      const active = items.find(item => item.dataset.mediaId === target);
      if (!active?.querySelector('.product__modal-opener--image')) return;
      items.forEach(item => item.classList.toggle('is-active', item === active));
      gallery.querySelectorAll('.thumbnail-list [data-target]').forEach(item => {
        const selected = item.dataset.target === target;
        item.classList.toggle('is-active', selected);
        const button = item.querySelector('button');
        if (selected) button?.setAttribute('aria-current', 'true');
        else button?.removeAttribute('aria-current');
      });
      active.parentElement.scrollTo({ left: active.offsetLeft });
    }

    move(event) {
      if (!this.opener || !this.mode.matches || event.pointerType === 'touch') return;
      const frame = this.opener.querySelector('.product__media');
      const rect = frame?.getBoundingClientRect();
      if (!rect?.width || !rect.height) return;
      const x = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
      const y = Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100));
      this.opener.style.setProperty('--ae-image-hover-origin', `${x}% ${y}%`);
    }

    out(event) {
      if (this.thumbnail?.contains(event.target) && !this.thumbnail.contains(event.relatedTarget)) this.reset();
      if (this.opener?.contains(event.target) && !this.opener.contains(event.relatedTarget)) this.reset();
    }

    reset() {
      clearTimeout(this.timer);
      this.thumbnail = null;
      this.opener?.classList.remove('ae-image-hover-active');
      this.opener?.style.removeProperty('--ae-image-hover-origin');
      this.opener = null;
    }
  });
}
